import { CountryCodes } from "@/constants/currency";

// ISO-2 country codes for your Tier-1 list
const TIER_1_COUNTRY_CODES = new Set([
    "US", // United States
    "AD", // Andorra
    "BS", // Bahamas
    "BH", // Bahrain
    "BB", // Barbados
    "BN", // Brunei
    "IS", // Iceland
    "IL", // Israel
    "JP", // Japan
    "KW", // Kuwait
    "LI", // Liechtenstein
    "MC", // Monaco
    "NZ", // New Zealand
    "NO", // Norway
    "OM", // Oman
    "QA", // Qatar
    "SM", // San Marino
    "SA", // Saudi Arabia
    "SG", // Singapore
    "KR", // South Korea
    "CH", // Switzerland
    "TW", // Taiwan
    "AE", // United Arab Emirates
]);

export const getIsCountryTier1 = (countryCode: CountryCodes) => {
    return TIER_1_COUNTRY_CODES.has(countryCode);
};
